import React from 'react';
import { Row, Col } from 'antd';

import { Main, BasicFormWrapper } from '../../styled.js';
import { Button } from '../../../components/buttons/buttons.js';
import { Cards } from '../../../components/cards/frame/cards-frame.js';
import { AddUser } from '../style.js';
import Heading from '../../../components/heading/heading.js';
import Spinner from '../../common/Spinner.js';

/**
 * ConfigView — read-only display of the host listing configuration.
 * Receives all display data as props from useHostListingConfig via ConfigAddEdit.
 */
const ConfigView = ({
  spinnerLoader,
  screens,
  viewCardBodyPadding,
  initialCardBodyPadding,
  configuration,
  selectedTheme,
  onEdit,
}) => {
  return (
    <>
      <Spinner loader={spinnerLoader} />
      <Main className="mainBlock pl-0 pr-0">
        <AddUser >
          <BasicFormWrapper>
            <div
              className="listing-split-layout"
            >
              <div className="listing-split-main">
                <Cards headless bodypadding={initialCardBodyPadding} className="borderRadius common_fiter_table">

                  {/* ── HEADER ─────────────────────────────────────── */}
                  <div className="info pb-38">
                    <Heading as="h3" className="mb-0 line_height_20">
                      <span>CONNECTION SETTINGS</span>
                    </Heading>
                  </div>

                  {/* ── LISTING IMAGE ──────────────────────────────── */}
                  <Row gutter={15} className="align-start-v">
                    <Col xs={24} md={8}>
                      <div className="image_upload_box">
                        <div className="upload-section">
                          <div className="listing_details_list">
                            <div className="detail_image_info">
                              <h4 className="image_label">Listing Image</h4>
                            </div>
                            <span>
                              <figure className="photo-upload align-center-v">
                                {configuration?.listing_image_url ? (
                                  <a
                                    href={configuration.listing_image_url}
                                    className="listing_details_photo_anchor"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      className="image_uploaded"
                                      src={configuration.listing_image_url}
                                      alt="Listing"
                                    />
                                  </a>
                                ) : (
                                  <img
                                    src={require('../../../static/img/avatar/building.png')}
                                    alt="Listing"
                                  />
                                )}
                              </figure>
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Cards>

                <Cards headless bodypadding={viewCardBodyPadding} className="mb-25 mt-25 borderRadius2 ">

                  {/* ── GUEST REGISTRATION — HOUSE RULES ──────────── */}
                  <Row gutter={15}>
                    <Col xs={24}>
                      <div className="info mb-38 line_height_20">
                        <Heading as="h3" className={'mb-0'}>
                          <span>GUEST REGISTRATION</span>
                        </Heading>
                      </div>
                      <ul className="custom-house-rules">
                        <h4 className="">House Rules</h4>
                        {configuration?.house_rules?.map((rule, index) => (
                          <li key={rule.id || index}>
                            <strong>{index + 1}. </strong>
                            {rule?.label}
                          </li>
                        ))}
                      </ul>
                    </Col>
                  </Row>

                 

                  {/* ── RENTAL AGREEMENT & ARRIVAL INSTRUCTIONS ───── */}
                  <Row gutter={15}>
                    {configuration?.rental_instructions && (
                      <Col xs={24} md={24}>
                        <div className="info listing_detail_lable">
                          <h4 className="">Short Term Rental Agreement</h4>
                          <span dangerouslySetInnerHTML={{ __html: configuration.rental_instructions }} />
                        </div>
                      </Col>
                    )}
                  </Row>


                  {/* ── SECONDARY FORM ─────────────────────────────── */}
                  {configuration?.form_title ? (
                    <Row gutter={15}>
                      <Col xs={24}>
                        <h4 className="listing_detail_lable">Secondary Form</h4>
                        <span>{configuration?.form_title}</span>
                      </Col>
                    </Row>
                  ) : <></>}
                </Cards>
                <Cards headless bodypadding={viewCardBodyPadding} className="mb-25 mt-25 borderRadius2 ">

                  <div className="info">
                    <Heading as="h3" className={'mb-0'}>
                      <span>ARRIVAL GUIDE</span>
                    </Heading>
                  </div>

                  {/* ── CONNECTION SETTINGS ────────────────────────── */}
                  <Row gutter={15}>
                    <Col xs={24} md={12}>
                      <h4 className="listing_detail_lable">Theme</h4>
                      <span className="listing_detail_value">
                        {selectedTheme?.theme_title}
                      </span>
                    </Col>

                    <Col xs={24} md={12}>
                      {configuration?.video && (
                        <>
                          <h4 className="listing_detail_lable">Welcome Video</h4>
                          <span className="listing_detail_value">{configuration?.video}</span>
                        </>
                      )}
                    </Col>
                    <Col xs={24} md={12}>
                      <h4 className="listing_detail_lable">Check-In Time</h4>
                      <span>{configuration?.checkin_time}</span>
                    </Col>
                    {/* ── CHECK TIME ─────────────────────────────────── */}
                    <Col xs={24} md={12}>
                      <h4 className="listing_detail_lable">Check-Out Time</h4>
                      <span>{configuration?.checkout_time}</span>
                    </Col>
                    <Col xs={24} md={12}>
                      <h4 className="listing_detail_lable">Wifi Name</h4>
                      <span className="listing_detail_value">{configuration?.wifi_name}</span>
                    </Col>

                    <Col xs={24} md={12}>
                      <h4 className="listing_detail_lable">Wifi Password</h4>
                      <span className="listing_detail_value">{configuration?.wifi_password}</span>
                    </Col>
                  </Row>

                {/* ── CHECK-IN VISIBILITY SETTINGS ──────────────── */}
                  <Row gutter={15}>
                    <Col xs={24}>
                      <div className="info listing_detail_title">
                        <Heading as="h3" className="mb-0 line_height_20">
                          <span>Check-In Instruction Visibility Settings</span>
                        </Heading>
                      </div>
                    </Col>
                    <Col xs={24}>
                      <h4 className="listing_detail_lable">
                        Begin displaying Arrival Instructions and Door Code directly after guests complete their
                        registration (uncheck for earlier display settings)
                      </h4>
                      <span>
                        {configuration?.is_display_arrival_and_checkout_instruction ? 'Yes' : 'No'}
                      </span>
                    </Col>
                  </Row>

                  {!configuration?.is_display_arrival_and_checkout_instruction && (
                    <Row gutter={15} className="map-details-container">
                      <Col xs={24} md={24}>
                        <h4 className="listing_detail_title">
                          Begin displaying my arrival and check-out instructions:
                        </h4>
                      </Col>
                      <Col xs={24} md={6}>
                        <h4 className="listing_detail_sub_value">Days before check-in day</h4>
                        <span>{configuration?.unlock_content_before_checkin_days}</span>
                      </Col>
                      <Col xs={24} md={6}>
                        <h4 className="listing_detail_sub_value">At (local time)</h4>
                        <span>{configuration?.unlock_content_before_checkin}</span>
                      </Col>
                      <Col xs={24} md={12}>
                        <h4 className="listing_detail_sub_value">
                          And then hide them on check-out day at (local time)
                        </h4>
                        <span>{configuration?.lock_content_after_checkout}</span>
                      </Col>
                    </Row>
                  )}

                  {/* ── CHECK-IN INSTRUCTIONS VISIBILITY SETTINGS ─────────────────────────── */}
                  <Row gutter={15}>
                    <Col xs={24}>
                      <h4 className="listing_detail_lable">
                        Even when my Arrival Instructions are visible, I want to hide the Door Code until time of check-in (uncheck for earlier display settings)
                      </h4>
                      <span>{configuration?.is_doorcode_visible ? 'Yes' : 'No'}</span>
                    </Col>
                  </Row>

                  {!configuration?.is_doorcode_visible && (
                    <Row gutter={15} className="map-details-container">
                      <Col xs={24} md={24}>
                        <div className="text-padding">
                          <h4 className="listing_detail_title">Begin displaying my Door Code:</h4>
                        </div>
                      </Col>
                      <Col xs={24} md={6}>
                        <h4 className="listing_detail_sub_value">Days before check-in day</h4>
                        <span>{configuration?.unlock_door_code_before_checkin_days}</span>
                      </Col>
                      <Col xs={24} md={6}>
                        <h4 className="listing_detail_sub_value">At (local time)</h4>
                        <span>{configuration?.unlock_door_code_before_checkin}</span>
                      </Col>
                      <Col xs={24} md={12}>
                        <h4 className="listing_detail_sub_value">
                          And then hide it on check-out day at (local time)
                        </h4>
                        <span>{configuration?.lock_door_code_after_checkout}</span>
                      </Col>
                    </Row>
                  )}

                  <Row gutter={15}>
                    <Col xs={24} md={24}>
                      <div className="info listing_detail_lable">
                        <Heading as="h3" className="mb-0 line_height_20">
                          <span>Arrival Instructions</span>
                        </Heading>
                      </div>
                      <span
                        className="custom_editor_span_text"
                        dangerouslySetInnerHTML={{ __html: configuration?.arrival_instructions || '' }}
                      />
                    </Col>
                  </Row>

                  {/* ── LOCAL GUIDES ───────────────────────────────── */}
                  <Row gutter={24}>
                    {!configuration?.use_individual_recommendation ? (
                      <Col xs={24} className="listing_detail_title">
                        <div className="map-details-container lable_map_detalis">
                          <Row gutter={15}>
                            <Col xs={24}>
                              <div className="info">
                                <Heading as="h3" className="mb-0 line_height_20">
                                  <span>LOCAL GUIDES AND LINKS</span>
                                </Heading>
                              </div>
                            </Col>
                          </Row>
                          <Row gutter={15}>
                            {['Image', 'Guide Title', 'Description', 'Guide URL'].map((label, idx) => (
                              <Col
                                key={idx}
                                xs={24}
                                md={idx === 0 ? 2 : idx === 3 ? 8 : idx === 2 ? 8 : 4}
                              >
                                <h4 className={screens?.xs ? 'listing_detail_row' : 'listing_detail_lable'}>
                                  {label}
                                </h4>
                              </Col>
                            ))}
                          </Row>
                        </div>

                        {configuration?.locals_map?.map((value, index) => (
                          <div key={index} className="map-details-container listing_map_details">
                            <Row gutter={15} className="align-items-center">
                              <Col xs={24} md={2}>
                                <div className={screens?.xs ? 'listing_detail_mt_19' : undefined}>
                                  <div className="map_image_sec">
                                    {value?.full_image_path && (
                                      <a
                                        href={value.full_image_path}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          className={
                                            value.full_image_path
                                              ? 'image_uploaded listingDetailsImageWidth'
                                              : 'image_placeholder'
                                          }
                                          src={
                                            value.full_image_path ||
                                            require('../../../static/img/image-placeholder.png')
                                          }
                                          alt="Preview"
                                        />
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </Col>
                              <Col xs={24} md={4}>
                                <div className={screens?.xs ? 'listing_detail_mt_19' : undefined}>
                                  <span className="value listing_detail_value">{value.title}</span>
                                </div>
                              </Col>
                              <Col xs={24} md={8}>
                                <div className={screens?.xs ? 'listing_detail_mt_19' : undefined}>
                                  <span className="value listing_detail_value">{value.description}</span>
                                </div>
                              </Col>
                              <Col xs={24} md={8}>
                                <div className={screens?.xs ? 'listing_detail_mt_19' : undefined}>
                                  <span className="value listing_detail_value">
                                    <a
                                      className="common_urlLink"
                                      href={value.redirect_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {value.redirect_url}
                                    </a>
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </Col>
                    ) : null}
                  </Row>

                  {/* ── HOUSE MANUAL ───────────────────────────────── */}
                  <Row gutter={15}>
                    {!configuration?.useGlobalHouseManual && configuration?.house_manual && (
                      <Col xs={24} md={24}>
                        <div className="listing_detail_lable">
                          <Heading as="h3" className="mb-0 line_height_20">
                            <span>House Manual</span>
                          </Heading>
                          <span
                            className="custom_editor_span_text"
                            dangerouslySetInnerHTML={{ __html: configuration.house_manual }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>

                  {/* ── CHECKOUT INSTRUCTIONS ──────────────────────── */}
                  <Row gutter={15}>
                    {!configuration?.useGlobalCheckoutInstructions && configuration?.checkout_instructions && (
                      <Col xs={24} md={24}>
                        <div className="listing_detail_lable">
                          <Heading as="h3" className="mb-0 line_height_20">
                            <span>Checkout Instructions</span>
                          </Heading>
                          <span
                            className="custom_editor_span_text"
                            dangerouslySetInnerHTML={{ __html: configuration.checkout_instructions }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                </Cards>
              </div>
            </div>
          </BasicFormWrapper>
        </AddUser>
      </Main>

      <div className="manage-listing-btn">
        <Button
          htmlType="button"
          outlined
          shape="circle"
          type="primary"
          key="edit"
          className="w-100 edit-btn"
          onClick={onEdit}
        >
          Edit
        </Button>
      </div>
    </>
  );
};

export default ConfigView;
